import DangerZone from './components/DangerZone';
import type { Database } from '@/types/database.types';
import RenameProjectForm from './components/RenameProjectForm';

type Project = Database['public']['Tables']['projects']['Row'];
type ProjectTeam = Database['public']['Tables']['projects_team']['Row'];
type Member = Database['public']['Tables']['project_members']['Row'];
type ProjectWithTeamAndMembers = Project & {
  projects_team: ProjectTeam;
} & { project_members: Member[] | null };

export default function SettingsTab({
  project,
}: {
  project: ProjectWithTeamAndMembers;
}) {
  return (
    <div className="space-y-8">
      <RenameProjectForm project={project} />
      <DangerZone project={project} />
    </div>
  );
}
